import axiosInstance from './axiosInstance'

export const getInstallationOptionById = (optionId) => {
  return axiosInstance.get(`/installation-options/${optionId}`)
}

export const getInstallationOptions = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.get(`/installation-options?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createInstallationOption = (data) => {
  return axiosInstance.post('/installation-options', data)
}

export const updateInstallationOption = (optionId, data) => {
  return axiosInstance.put(`/installation-options/${optionId}`, data)
}

export const deleteInstallationOption = (optionId) => {
  return axiosInstance.delete(`/installation-options/${optionId}`)
}
